export default __webpack_public_path__ + "static/icon-spacing-light-d77db8c4d741bb725d3e345feaf80a0d4960e936c9769e38b3764bc7b9c974fb.png";